import React from 'react';
import { ModuleBase, Stack, Text, Link, Box } from '@/components';
import { SideBySideModuleModel } from './SideBySideModule';
import classNames from 'classnames';

const GlobalDataDecisionEngine = (data: SideBySideModuleModel) => {
  const {
    props: { alignment, title, description, cards },
  } = data;

  return (
    <ModuleBase
      data={{ ...data, props: { ...data.props, backgroundColour: '#1B3E4E' } }}
      className="GlobalDataDecisionEngine overflow-hidden"
    >
      <Stack
        className={classNames(
          'container flex flex-col justify-between gap-5 lg:mb-10 lg:gap-10 xl:gap-20',
          alignment === 'Right' ? 'lg:flex-row-reverse' : 'lg:flex-row',
        )}
      >
        <div className="color-from-bg h-full w-full lg:w-1/2 xl:pr-10">
          {title && (
            <Text
              className="text-style-h2 mt-6 xl:!text-[50px] xl:leading-[50px]"
              dangerouslySetInnerHTML={{ __html: title }}
            />
          )}
          {description && (
            <Text className="text-style-h4 mt-6 md:mt-10 lg:mt-16" dangerouslySetInnerHTML={{ __html: description }} />
          )}
        </div>
        <div className="color-from-bg relative w-full flex-grow lg:w-1/2">
          {cards && (
            <div className="mt-5 flex-col md:mt-10">
              {cards.map((card, index) => (
                <Box
                  key={index}
                  className={classNames(
                    index !== 0 && 'lg:after-extended-line-top border-t lg:border-t-0',
                    'border-from-bg relative flex flex-col gap-1 pt-5 pb-5 first:pt-0',
                  )}
                >
                  <p className="text-style-h4">{card.title}</p>
                </Box>
              ))}
            </div>
          )}
        </div>
      </Stack>
    </ModuleBase>
  );
};

export default GlobalDataDecisionEngine;
